export default __webpack_public_path__ + "static/media/bw-working-memory-tutorial-pop-up-step-2.467069f7.svg";